export const PENDING = 'pending'
export const REJECTED = 'rejected'
export const RESOLVED = 'resolved'
export const IDLE = 'idle'
